export default __webpack_public_path__ + "static/media/mongodb-.e4025ae2.svg";